// eslint-disable-next-line import/no-unresolved
import { Config, Layout, PlotData } from 'plotly.js-basic-dist';

const CHART_HEIGHT = 300;

export const getYTraceConfig = (name: string, showLegend = true): Partial<PlotData> => ({
  hoverinfo: 'none',
  line: { shape: 'hv', color: '#6210CC' },
  mode: 'lines',
  name,
  showlegend: showLegend,
  type: 'scatter',
});

export const getY2TraceConfig = (name: string, showLegend = true): Partial<PlotData> => ({
  hoverinfo: 'none',
  line: { shape: 'hv', color: '#278E6C' },
  mode: 'lines',
  name,
  showlegend: showLegend,
  type: 'scatter',
  yaxis: 'y2',
});

export const plotDefaultConfig: Partial<Config> = {
  autosizable: true,
  displayModeBar: false,
  responsive: true,
  showAxisDragHandles: false,
  showTips: false,
};

export const plotLayoutConfig: Partial<Layout> = {
  autosize: true,
  dragmode: false,
  font: {
    family:
      'system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, Ubuntu, "Helvetica Neue"',
  },
  height: CHART_HEIGHT,
  hoverdistance: 2,
  hovermode: 'x',
  margin: {
    t: 0,
    r: 39,
    b: 30,
    l: 25,
    pad: 4,
  },
  xaxis: {
    fixedrange: true,
    showgrid: false,
    showspikes: true,
    spikecolor: '#576670',
    spikedash: 'solid',
    spikemode: 'across',
    spikesnap: 'cursor',
    spikethickness: 2,
    tickfont: {
      size: 12,
      color: '#576670',
    },
    // @ts-ignore exported Layout type does not have ticklabelposition property
    ticklabelposition: 'outside left',
    zeroline: false,
  },
  yaxis: {
    constraintoward: 'bottom',
    fixedrange: true,
    gridcolor: '#DCE1E4',
    side: 'left',
    tickfont: {
      color: '#141D24',
      size: 12,
    },
    // @ts-ignore exported Layout type does not have ticklabelposition property
    ticklabelposition: 'outside',
    zeroline: false,
  },
  yaxis2: {
    fixedrange: true,
    overlaying: 'y',
    side: 'right',
    tickfont: {
      color: '#576670',
      size: 12,
    },
    zeroline: false,
  },
  showlegend: true,
  legend: {
    itemclick: false,
    itemdoubleclick: false,
    orientation: 'h',
    xanchor: 'center',
    x: 0.5,
    y: 1.1,
    font: {
      color: '#141D24',
    },
  },
};
